import type { FC, SVGProps } from "react";

const IconFreeWifi: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
  <path d="M11 16H11.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M1 4.8199C3.75011 2.36013 7.31034 1.00024 11 1.00024C14.6897 1.00024 18.2499 2.36013 21 4.8199" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4 8.85906C5.86929 7.02679 8.38247 6.00049 11 6.00049C13.6175 6.00049 16.1307 7.02679 18 8.85906" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M7.5 12.429C8.43464 11.5129 9.69124 10.9998 11 10.9998C12.3088 10.9998 13.5654 11.5129 14.5 12.429" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconFreeWifi;